// Local DTOs mirroring the backend CqmTraceability endpoint until @medone/medonehp-api-client
// republishes with the generated CqmTraceabilityClient (imports-models.ts pattern).

import { CqmMeasureResultVersionDto } from './imports-models';

// Re-exported so traceability consumers get the version + trace types from one module. The
// imports-models mirror (string calcTimestamp) matches the raw-JSON fallback response and is
// the type ProvenanceView already consumes; the generated class deserializes to moment instead.
export type { CqmMeasureResultVersionDto } from './imports-models';

export interface CqmValueSetRefDto {
    oid: string;
    name?: string | null;
    version?: string | null;
}

export interface CqmCodeValueSetMatchDto {
    code: string;
    systemOid: string;
    valueSets: CqmValueSetRefDto[];
}

export interface CqmPatientMeasureTraceDto {
    patientId: number;
    measureCmsId: string;
    year: number;
    versions: CqmMeasureResultVersionDto[];
    codeValueSetMatches: CqmCodeValueSetMatchDto[];
    /** Unrendered payload provenance — kept for wire-DTO fidelity until the generated-client swap. */
    matchesComputedFromMeasureVersion?: string | null;
}

export interface TraceabilityState {
    loading: boolean;
    errorMessage: string | null;
    trace: CqmPatientMeasureTraceDto | null;
    // RTK requestId of the newest fetch — later-arriving stale responses are ignored.
    currentRequestId: string | null;
}

export const initialTraceabilityState: TraceabilityState = {
    loading: false,
    errorMessage: null,
    trace: null,
    currentRequestId: null,
};
